import { AppState } from '@Redux/store';
import { DraftTeam, Draw, Nullable } from '@Models';
import { DraftState } from '@Stores/index';
import { DraftTeamState } from '@Stores/index';
import { ArmiesState } from '@Stores/index';
import { MapsState } from '@Stores/index';

export const getDraft = (state: AppState): DraftState => state.draft;

export const getMyTeam = (state: AppState): DraftTeamState => state.myTeam;

export const getArmies = (state: AppState): ArmiesState => state.armies;

export const getDrawProps = (state: AppState, props: any): DrawProps => props;

export const getMyTeamEntity = (state: AppState): Nullable<DraftTeam> =>
  getMyTeam(state).entity;

export const getMyDrawEntity = (state: AppState): Nullable<Draw> =>
  state.myDraw.entity;

export const getOpponentDrawEntity = (state: AppState): Nullable<Draw> =>
  state.opponentDraw.entity;

export const getMaps = (state: AppState): MapsState => state.maps;

export type DrawProps = {
  displayDraw: boolean;
  displayResponse: boolean;
  draw: Nullable<Draw>;
  my: boolean;
  selectable: boolean;
  displaySelected: boolean;
};
